import { FC, PropsWithChildren } from 'react'
import { useLang } from './useLang'
import { IntlProvider } from 'react-intl'
import '@formatjs/intl-relativetimeformat/polyfill'
import '@formatjs/intl-relativetimeformat/locale-data/en'
import '@formatjs/intl-relativetimeformat/locale-data/de'
import '@formatjs/intl-relativetimeformat/locale-data/es'
import '@formatjs/intl-relativetimeformat/locale-data/fr'
import '@formatjs/intl-relativetimeformat/locale-data/ja'
import '@formatjs/intl-relativetimeformat/locale-data/zh'

import enMessages from './messages/en'
import frMessages from './messages/fr'

const allMessages = {
  en: enMessages,
  fr: frMessages,
}

const I18nProvider: FC<PropsWithChildren> = ({ children }) => {
  const { selectedLocale } = useLang()
  const messages = allMessages[selectedLocale]

  return (
    <IntlProvider locale={selectedLocale} messages={messages}>
      {children}
    </IntlProvider>
  )
}

export { I18nProvider }
